import { useCallback } from 'react'

const useOnChange = ({ onChange, value, country }) => {
  const handleCodeChange = useCallback(
    (code) => {
      if (!code) return
      onChange({ code, phone: value?.phone })
    },
    [onChange, value]
  )

  const handleNumberChange = useCallback(
    (e) => {
      const phone = e.target.value.replace(/\D/g, '') || ''
      const isValidUs = country?.code === 'US' && phone.length <= 10
      const isValidOther = country?.code !== 'US' && phone.length <= 20
      const isValidCountryLength = isValidUs || isValidOther
      const isShortening = !!value.phone && phone.length < value.phone.length

      if (isValidCountryLength || isShortening) onChange({ code: value?.code, phone })
    },
    [onChange, value, country]
  )

  return { handleCodeChange, handleNumberChange }
}

export default useOnChange
